import { useState, useRef } from 'react';

const useCostingSummaryFilters = () => {
    const [costingSummaryFilters, setCostingSummaryFilters] = useState({
        sites: [], providers: [], roles: [], weeks: [], periods: []
    });
    const costingSummaryClearRef = useRef(null);

    const handleCostingSummaryClearFilters = () => {
        setCostingSummaryFilters({ sites: [], providers: [], roles: [], weeks: [], periods: [] });
        costingSummaryClearRef.current?.();
    };

    return {
        costingSummaryFilters,
        setCostingSummaryFilters,
        costingSummaryClearRef,
        handleCostingSummaryClearFilters,
    };
};

export default useCostingSummaryFilters;
